import MockTranslationHelper, { expectTranslationHelper } from './MockTranslationHelper';

const DefaultLocale = 'en';
const SupportedLocales = ['en', 'es', 'it', 'zh', 'ar', 'am'];

export { DefaultLocale, SupportedLocales };
export type * from './TranslationHelper.types';
export { MockTranslationHelper, expectTranslationHelper };
